export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "./images/svg/symbols.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }